<style>
    svg {
        display: inline-block;
        height: 24px;
        width: 24px;
    }
</style>
<svg viewBox="10 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <use href="#bd-check" x="10" fill="#367ae0" />
</svg>